module.exports = __webpack_public_path__ + "static/media/bs_1.c2c4db8b.jpg";